import { render } from "./FilterUsers.vue?vue&type=template&id=1353f08c"
import script from "./FilterUsers.vue?vue&type=script&lang=js"
export * from "./FilterUsers.vue?vue&type=script&lang=js"
script.render = render

export default script